import { defineStore } from 'pinia';
import * as Sentry from "@sentry/nuxt";
import { useAuthStore } from '~/stores/auth';

export const useGlobalStore = defineStore('globalStore', {
  state: () => ({
    isMaintenanceModeEnabled: null as boolean | null,
    isCspProgramFull: null as boolean | null,
    cspProgramFullMessage: null as string | null,
    pollingInterval: null as ReturnType<typeof setInterval> | null,
  }),
  actions: {
    async fetchCspStatus() {
      try {
        const { $api } = useNuxtApp();
        const status = await $api<{ isMaintenanceMode: boolean; isCspProgramFull: boolean; cspProgramFullMessage: string | null }>('/public/v1/csp/status');
        this.isMaintenanceModeEnabled = status.isMaintenanceMode;
        this.isCspProgramFull = status.isCspProgramFull;
        this.cspProgramFullMessage = status.cspProgramFullMessage;
      } catch (error) {
        Sentry.captureException(error);
      }
    },
    startPolling() {
      if (!this.pollingInterval) {
        this.fetchCspStatus();
        // Start polling every 30 seconds to check for CSP status flags
        this.pollingInterval = setInterval(async () => {
          await this.fetchCspStatus();
        }, 30000); // Poll every 30 seconds
      }
    },
    toggleMaintenanceMode() {
      const authStore = useAuthStore();
      if (authStore.isAuthenticated && authStore.isSystemAdmin) {
        this.isMaintenanceModeEnabled = !this.isMaintenanceModeEnabled;
        this.fetchCspStatus();
      } else {
        Sentry.captureMessage('Unauthorized attempt to toggle maintenance mode');
      }
    },
  },
});